import { useParams } from "react-router-dom";

export function useLangUrl() {
    const { lang } = useParams();
    return `/${lang}`;
}
